class lifetimeWarranty extends HTMLElement {
    constructor() {
        super();
        this.id = parseInt(this.dataset.id);
        this.matchqty = this.dataset.matchqty;
        this.lifetimeWarrantyQty = parseInt(this.dataset.lifetimewarrantyqty);
        this.CompareProductQty = parseInt(this.dataset.compareproductqty);
        this.totalqty = this.CompareProductQty - this.lifetimeWarrantyQty;
        this.removetotalqty = this.CompareProductQty;

        this.toggleSwitch = localStorage.getItem("toggleSwitch");
        this.setAccessibility();
        this.checkqty();
    }

    setAccessibility() {
        const toggleSwitch = this.querySelectorAll('.toggle-switch');

        toggleSwitch.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            this.activelifetimeWarranty(element);
        });
        });
    }

    disabledtoggleSwitch(element){
        element.setAttribute('disabled', true);
    }

    selectedtoggleSwitch() {
        if (this.dataset.selected === 'true') {
            this.dataset.selected = 'false';
            localStorage.setItem("toggleSwitch", "false");
            this.toggleSwitch = localStorage.getItem("toggleSwitch");
        } else {
            this.dataset.selected = 'true';
            localStorage.setItem("toggleSwitch", "true");
            this.toggleSwitch = localStorage.getItem("toggleSwitch");
        }

        return this.dataset.selected;
    }

    activelifetimeWarranty(element){
        this.disabledtoggleSwitch(element);
        var selected = this.selectedtoggleSwitch();
        
        if(selected == 'false'){
            this.removelifetimeWarranty(0);
        }else if(selected == 'true'){
            this.addlifetimeWarranty(this.totalqty);
        }
    }

    checkqty(){
        if(this.toggleSwitch == 'true'){
            if(this.totalqty < 0){
                this.removelifetimeWarranty(this.removetotalqty)
            }else if(this.matchqty == 'false'){
                this.addlifetimeWarranty(this.totalqty)
            }
        }
    }

    async addlifetimeWarranty(qty) {
        const sections = this.getSectionsToRender().map((section) => section.id);

        const body = JSON.stringify({
        id: this.id,
        quantity: qty,
        sections: sections,
        sections_url: window.location.pathname,
        });

        try {
        const response = await fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
            },
            body,
        });

        if (response.status === 422) {
            const errorData = await response.json();
            // Handle error (e.g., show a notification)
            console.error("Error adding item to cart:", errorData.description);
            return;
        }

        const parsedState = await response.json();
        this.renderContents(parsedState);
        } catch (error) {
        console.error("Error adding item to cart:", error);
        }
    }

    async removelifetimeWarranty(qty) {
        const sections = this.getSectionsToRender().map((section) => section.id);

        const body = JSON.stringify({
        id: this.id,
        quantity: qty,
        sections: sections,
        sections_url: window.location.pathname,
        });

        try {
        const response = await fetch(`${routes.cart_change_url}`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
            },
            body,
        });

        if (response.status === 422) {
            const errorData = await response.json();
            // Handle error (e.g., show a notification)
            console.error("Error adding item to cart:", errorData.description);
            return;
        }

        const parsedState = await response.json();
        this.renderContents(parsedState);
        } catch (error) {
        console.error("Error adding item to cart:", error);
        }
    }

    renderContents(parsedState) {
        document.querySelector(".drawer__inner").classList.contains("is-empty") &&
        document.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        if (!sectionElement) return;
        if (section.id == "cart-drawer" || section.selector == "#CartDrawer") {
            const newCartDrawer = this.getSectionDOM(
            parsedState.sections[section.id],
            section.selector
            );
            updateCartDrawer(sectionElement, newCartDrawer);
        } else {
            sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
            );
        }
        });
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector);
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
        {
            id: "cart-drawer",
            selector: "#CartDrawer",
        },
        {
            id: "cart-icon-bubble",
        },
        ];
    }
}


customElements.define('lifetime-warranty', lifetimeWarranty);